<template lang="pug">
  .vue__registration-closed
    FaIcon(:icon="['far', 'calendar-times']" size="3x")

    template( v-if="interestIs('CoursePrefix')" )
      h4
        | На данный момент регистрация на
        |
        span.text-nowrap
          | курс закрыта
      p Следите за новостями онлайн-школы!
      BaseButton( tag="a" :href="resourcesUrl" )
        FaIcon(icon="arrow-left" class="fa-fw")
        |
        | Обзор курсов

    template( v-else-if="interestIs('Webinar')" )
      h4
        | Вебинар был проведен {{registrationClosesAt}}
      p Следите за новостями онлайн-школы!
      BaseButton( tag="a" :href="resourcesUrl" )
        FaIcon(icon="arrow-left" class="fa-fw")
        |
        | Ближайшие вебинары

    template( v-else-if="interestIs('OfflineEvents::Event')" )
      h4
        | Мероприятие завершено {{registrationClosesAt}}
      p Следите за новостями онлайн-школы!
      BaseButton( tag="a" :href="resourcesUrl" )
        FaIcon(icon="arrow-left" class="fa-fw")
        |
        | Ближайшие мероприятия
    template( v-else-if="interestIs('Webinars::Sets::Set')" )
      h4
        | Семинар завершен!
      p Следите за новостями онлайн-школы!
    template( v-else-if="interestIs('CustomProducts::CustomProduct') || interestIs('CustomInterest')" )
      h4
        | Регистрация закрыта

</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapState([
        'registrationClosesAt',
        'resourcesUrl',
      ]),

      ...mapGetters(['interestIs']),
    },
  };
</script>

<style lang="scss" scoped>
  .vue__registration-closed {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .fa-calendar-times path {
      fill: #999;
    }

    h4 {
      margin-top: 10px;
      font-weight: 400;
      font-size: 20px;
    }

    p {
      font-size: 17px;
    }
  }
</style>
